<script lang="ts" setup>
import BcDropdownItem from '@/ui-kit/components/BcDropdown/BcDropdownItem.vue';
import BcDropdown from '@/ui-kit/components/BcDropdown/BcDropdown.vue';
import BcDropdownTrigger from '@/ui-kit/components/BcDropdown/BcDropdownTrigger.vue';

import { computed } from 'vue';
import { TCourtesyTitle, useCourtesyTitle } from '@/composables/useCourtesyTitle';

const props = withDefaults(defineProps<{
  courtesyTitle: TCourtesyTitle;
  isRequired: boolean;
}>(), {
  courtesyTitle: 0,
  isRequired: false,
});

const emit = defineEmits<{
  (e: 'update-value', value: { courtesyTitle: TCourtesyTitle }): void;
}>();

const { courtesyTitleOptions, getCourtesyTitle } = useCourtesyTitle();

const courtesyTitle = computed<string>(() => {
  return getCourtesyTitle(props.courtesyTitle);
});

const selectCourtesyTitle = (option: { value: TCourtesyTitle; label: string }) => {
  emit('update-value', { courtesyTitle: option.value });
};
</script>

<template>
  <bc-dropdown
    :options="courtesyTitleOptions"
    @change="selectCourtesyTitle"
    :is-popper="true"
    class="panel-coder-edit-courtesy-title w-full"
  >
    <template #label="{ isDropdownOpen }">
      <bc-dropdown-trigger
        :is-arrow="true"
        :is-dropdown-open="isDropdownOpen"
        :is-label-placeholder="false"
        :required="isRequired"
        :text="courtesyTitle"
        :label="$t('generics.civility')"
      >
      </bc-dropdown-trigger>
    </template>
    <template #option="{ option, index, activeIndex }">
      <bc-dropdown-item
        :is-focus="activeIndex === index"
        :text="option.label"
        @change="selectCourtesyTitle"
        @click.native="selectCourtesyTitle(option)"
      >
      </bc-dropdown-item>
    </template>
  </bc-dropdown>
</template>

<style lang="scss" scoped>
.panel-coder-edit-courtesy-title {
  &:deep(.bc-dropdown-trigger__label--focus) {
    transform: translate(-10px, -30px);
  }

  &:deep(.bc-dropdown-trigger) {
    @apply bg-blue-500 !text-white;
  }

  &:deep(.bc-dropdown-trigger__text) {
    @apply w-full !max-w-full text-left;
  }
}
</style>
